import TreeNode from './tree-node';
// 此处不能使用 import { makeTreeNode } from '@ss/mtd-vue/es/components/tree' 会造成循环依赖
import createTreeNode from '@ss/mtd-vue/es/components/tree/make';

var MtdTreeNode = createTreeNode('MtdTreeNode', TreeNode);
/* istanbul ignore next */
MtdTreeNode.install = function (Vue) {
  Vue.component(MtdTreeNode.name, MtdTreeNode);
};
export default MtdTreeNode;